import React from 'react';
import { Route, Switch } from 'wouter';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Booking from '../routes/booking/Booking';
import Journey from '../routes/journey/Journey';
import Login from '../routes/login/Login';
import JourneyEdit from '../routes/journeyEdit/JourneyEdit';
import AutoLogin from '../routes/autoLogin/AutoLogin';
import { Header } from '../components/header/Header';

const Payment = React.lazy(() => import('../routes/payment/Payment'));

export const RouteSwitcher: React.FC = () => {
  const flags = useFlags();

  return (
    <>
      <Header />
      <Switch>
        <Route path="/" component={Login} />
        <Route path="/booking/:bookingCode" component={Booking} />
        <Route path="/booking/:bookingCode/journey/:journeyId" component={Journey} />
        <Route path="/booking/:bookingCode/journey/:journeyId/edit" component={JourneyEdit} />
        {flags?.showPaymentPage && <Route path="/booking/:bookingCode/journeyChange/:journeyChangeId/payment" component={Payment} />}
        <Route path="/:bookingOrJourneyCode/:lastName" component={AutoLogin} />
      </Switch>
    </>
  );
};
